import React, { useEffect } from 'react';
import LandingFooter from '../../components/layouts/LandingFooter';
import AOS from 'aos';
import 'aos/dist/aos.css';

const HowWorks: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, delay: 300 });
  }, []);

  return (
    <>
      <div className="d-flex flex-column bg-base-light flex-center w-100 min-h-300px z-index-n1 min-h-lg-450px px-9 bg-leaves">
        <img src="/media/lemon.png" className="w-325px lemon-img position-absolute right-0 me-15 z-index-0 img-responsive" alt="" />
        <img src="/media/vegetable.png" className="vegetable-img position-absolute z-index-0 img-responsive" alt="" />
        <div className="row w-100 mx-auto">
          <div className="col-md-8 mx-auto text-center">
            <div className="mb-5 mb-lg-10 py-10 py-lg-20">
              <h1 className="text-base-dark lh-base fw-bold fs-1x fs-lg-3x mb-5 text-uppercase font-bold" data-aos="fade-up">How it works</h1>
              <br />
              <p className="text-base-dark fs-lg-3 font-light" data-aos="fade-up">Learn how to use Fesilah to care for your plants.</p>
              <img src="/media/vegetable2.png" className="w-325px vegetable2-img position-absolute z-index-0 img-responsive" alt="" />
              <img src="/media/tomato.png" className="tomato-img position-absolute right-0 z-index-0 img-responsive" alt="" />
              <br />
            </div>
          </div>
        </div>
      </div>
      <img src="/media/Wave.png" className="w-100 curve" alt="" />
      <div className="mb-n10 mb-lg-n20 z-index-2 min-h-300px inner-box">
        <div className="container">
          <div className="row mt-5">
            <div className="col-12 col-md-10 mx-auto shadow bg-white mb-15 inner-content">
              <div className="row p-lg-15 text-center mx-auto">
                <p className="z-index-1" data-aos="fade-up">
                  <img src="/media/step1.png" className="img-responsive w-50" alt="" />
                </p>
                <img src="/media/step1-shop.png" data-aos="fade-up" style={{ marginTop: '-5rem' }} className="img-responsive w-100" alt="" />
                <p className="fs-2tx mt-5" data-aos="zoom-in">Explore the app</p>
                <p data-aos="zoom-in">Using Fesilah, you can browse plants and get expert advice</p>
                <p className="z-index-1" data-aos="fade-up">
                  <img src="/media/step2.png" className="img-responsive" style={{ marginTop: '-1rem' }} width="35%" alt="" />
                </p>
                <img src="/media/surprise.png" data-aos="fade-up" style={{ marginTop: '-5rem' }} className="img-responsive w-100" alt="" />
                <p className="fs-2tx mt-5" data-aos="zoom-in">Connect with Experts</p>
                <p data-aos="zoom-in">Get personalized advice from agricultural consultants</p>
                <p className="z-index-1" data-aos="fade-up">
                  <img src="/media/step3.png" className="img-responsive" style={{ marginTop: '-1rem' }} width="35%" alt="" />
                </p>
                <img src="/media/reserve.png" data-aos="fade-up" style={{ marginTop: '-5rem' }} className="img-responsive w-100" alt="" />
                <p className="fs-2tx mt-5" data-aos="zoom-in">Get Help</p>
                <p data-aos="zoom-in">Receive expert guidance for all your plant care needs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LandingFooter />
    </>
  );
};

export default HowWorks;
















